/* Babywearing library directory — interactive list + Leaflet map.
   Consumes the spec-shape library objects (see docs/babywearing-directory-build-spec.md §1).
   Data source is a single seam: an inline <script type="application/json" data-bwd-data>
   blob if present (future metaobject path), otherwise fetched from the root's data-src
   (interim asset path). Swapping the data source needs no change in this file. */
(function () {
  var root = document.querySelector('[data-bwd-root]');
  if (!root) return;

  var STATES = { AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas', CA: 'California', CO: 'Colorado', CT: 'Connecticut', DE: 'Delaware', FL: 'Florida', GA: 'Georgia', HI: 'Hawaii', ID: 'Idaho', IL: 'Illinois', IN: 'Indiana', IA: 'Iowa', KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana', ME: 'Maine', MD: 'Maryland', MA: 'Massachusetts', MI: 'Michigan', MN: 'Minnesota', MS: 'Mississippi', MO: 'Missouri', MT: 'Montana', NE: 'Nebraska', NV: 'Nevada', NH: 'New Hampshire', NJ: 'New Jersey', NM: 'New Mexico', NY: 'New York', NC: 'North Carolina', ND: 'North Dakota', OH: 'Ohio', OK: 'Oklahoma', OR: 'Oregon', PA: 'Pennsylvania', RI: 'Rhode Island', SC: 'South Carolina', SD: 'South Dakota', TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VT: 'Vermont', VA: 'Virginia', WA: 'Washington', WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming', DC: 'Washington DC', DMV: 'DC Maryland Virginia' };

  // Rough US ZIP (first 3 digits) -> state. Offline, ~state-level accurate.
  var ZIP_RANGES = [[5, 5, 'NY'], [6, 9, 'PR'], [10, 27, 'MA'], [28, 29, 'RI'], [30, 38, 'NH'], [39, 49, 'ME'], [50, 59, 'VT'], [60, 69, 'CT'], [70, 89, 'NJ'], [100, 149, 'NY'], [150, 196, 'PA'], [197, 199, 'DE'], [200, 205, 'DC'], [206, 219, 'MD'], [220, 246, 'VA'], [247, 268, 'WV'], [270, 289, 'NC'], [290, 299, 'SC'], [300, 319, 'GA'], [320, 349, 'FL'], [350, 369, 'AL'], [370, 385, 'TN'], [386, 397, 'MS'], [398, 399, 'GA'], [400, 427, 'KY'], [430, 459, 'OH'], [460, 479, 'IN'], [480, 499, 'MI'], [500, 528, 'IA'], [530, 549, 'WI'], [550, 567, 'MN'], [570, 577, 'SD'], [580, 588, 'ND'], [590, 599, 'MT'], [600, 629, 'IL'], [630, 658, 'MO'], [660, 679, 'KS'], [680, 693, 'NE'], [700, 714, 'LA'], [716, 729, 'AR'], [730, 749, 'OK'], [750, 799, 'TX'], [800, 816, 'CO'], [820, 831, 'WY'], [832, 838, 'ID'], [840, 847, 'UT'], [850, 865, 'AZ'], [870, 884, 'NM'], [889, 898, 'NV'], [900, 961, 'CA'], [967, 968, 'HI'], [970, 979, 'OR'], [980, 994, 'WA'], [995, 999, 'AK']];
  function usZipState(zip) { if (!/^\d{5}$/.test(zip)) return null; var p = parseInt(zip.slice(0, 3), 10); for (var i = 0; i < ZIP_RANGES.length; i++) { var r = ZIP_RANGES[i]; if (p >= r[0] && p <= r[1]) return r[2]; } return null; }
  // Some listings use the "DMV" region (DC/Maryland/Virginia). A DC/MD/VA zip should match those too.
  var ZIP_STATE_ALIASES = { DC: ['DC', 'DMV'], MD: ['MD', 'DMV'], VA: ['VA', 'DMV'] };
  function distMi(a, d) { var R = 3958.8, r = function (x) { return x * Math.PI / 180; }; var dLat = r(d.latitude - a.lat), dLng = r(d.longitude - a.lng); var s = Math.sin(dLat / 2) ** 2 + Math.cos(r(a.lat)) * Math.cos(r(d.latitude)) * Math.sin(dLng / 2) ** 2; return 2 * R * Math.asin(Math.sqrt(s)); }
  function expandStates(sr) { return String(sr || '').split(/[^A-Za-z]+/).map(function (t) { return STATES[t.toUpperCase()] || ''; }).join(' '); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }

  // Derived helpers on the spec-shape object.
  function hasHP(d) { return !!(d.carriers && d.carriers.length); }
  function isOnline(d) { return d.meeting_type === 'online' || d.meeting_type === 'both'; }

  var el = {
    q: root.querySelector('#bwd-q'),
    nearme: root.querySelector('#bwd-nearme'),
    geostatus: root.querySelector('#bwd-geostatus'),
    list: root.querySelector('#bwd-list'),
    mapview: root.querySelector('#bwd-mapview'),
    mapEl: root.querySelector('#bwd-map'),
    count: root.querySelector('#bwd-count'),
    mapcount: root.querySelector('#bwd-mapcount'),
    reset: root.querySelector('#bwd-reset'),
    openMap: root.querySelector('#bwd-openMap'),
    closeMap: root.querySelector('#bwd-closeMap'),
    more: root.querySelector('#bwd-more'),
    showmore: root.querySelector('#bwd-showmore'),
    showall: root.querySelector('#bwd-showall')
  };

  var DATA = [];
  var CARRIER_URLS = {}; // carrier type -> collection/product URL (from Liquid; type may be absent)
  var PAGE_SIZE = 8;     // list reveals in batches so the CTA below isn't a long scroll away
  var state = { q: '', filters: new Set(), mapReady: false, sortByDistance: false, userLoc: null, visible: PAGE_SIZE };
  var isDesktop = function () { return window.matchMedia('(min-width:960px)').matches; };

  function matches(d) {
    var q = state.q.trim().toLowerCase();
    if (q) {
      var zs = usZipState(q);
      if (zs) {
        var parts = String(d.state_region || '').toUpperCase().split(/[^A-Z]+/).filter(Boolean);
        var accept = ZIP_STATE_ALIASES[zs] || [zs];
        if (!accept.some(function (s) { return parts.indexOf(s) !== -1; })) return false;
      } else {
        var hay = [d.name, d.city_region, d.state_region, expandStates(d.state_region), d.country, d.country === 'USA' ? 'united states usa america' : ''].join(' ').toLowerCase();
        if (hay.indexOf(q) === -1) return false;
      }
    }
    var fs = state.filters;
    if (fs.has('hp') && !hasHP(d)) return false;
    if (fs.has('lending') && !(d.library_status === 'full' || d.library_status === 'partial')) return false;
    if (fs.has('tryon') && ['tryon', 'partial', 'full'].indexOf(d.library_status) === -1) return false;
    if (fs.has('free') && !/free/i.test(d.meeting_price || '')) return false;
    return true;
  }

  function libBadge(d) {
    switch (d.library_status) {
      case 'full': return '<span class="bwd__badge bwd__badge--lending">Lending library</span>';
      case 'partial': return '<span class="bwd__badge bwd__badge--lending">Lending (some try-on)</span>';
      case 'tryon': return '<span class="bwd__badge bwd__badge--tryon">Try-on only</span>';
      case 'none': return '<span class="hp-badge hp-badge--muted">Meet-ups only</span>';
      default: return '<span class="hp-badge hp-badge--muted">Library TBC</span>';
    }
  }

  function carrierChip(c) {
    var len = c.lengths && c.lengths.length ? '<span class="bwd__len">' + esc(c.lengths.join(' / ')) + '</span>' : '';
    var fib = c.fibre ? '<span class="bwd__len">' + esc(c.fibre) + '</span>' : '';
    var qty = c.quantity ? '<span class="bwd__len">×' + esc(c.quantity) + '</span>' : '';
    var inner = '<b>' + esc(c.type) + '</b>' + len + fib + qty;
    var url = CARRIER_URLS[c.type];
    // Link chips to the carrier's collection (products can be retired; collections persist).
    if (url) {
      return '<a class="hp-badge hp-badge--soft bwd__cchip bwd__cchip--link" href="' + esc(url) + '" aria-label="Shop ' + esc(c.type) + '">' + inner + '</a>';
    }
    return '<span class="hp-badge hp-badge--soft bwd__cchip">' + inner + '</span>';
  }

  function cardHTML(d) {
    var dist = (state.sortByDistance && d._mi != null) ? '<span class="hp-badge hp-badge--purple">📍 ' + (d._mi < 1 ? '<1' : Math.round(d._mi)) + ' mi</span>' : '';
    var badges = [
      dist,
      hasHP(d) ? '<span class="hp-badge hp-badge--soft">💜 hope&plum carriers</span>' : '',
      libBadge(d),
      /free/i.test(d.meeting_price || '') ? '<span class="bwd__badge bwd__badge--free">Free meet-ups</span>' : '',
      isOnline(d) ? '<span class="hp-badge hp-badge--purple">Online support</span>' : ''
    ].join('');
    var price = (d.library_price && ['none', 'unknown'].indexOf(d.library_status) === -1) ? '<p class="bwd__detail"><b>Lending:</b> ' + esc(d.library_price) + '</p>' : '';
    var tryon = hasHP(d) ? '<div class="bwd__tryon"><p class="bwd__tryon-title">💜 hope&plum to try here</p><div class="bwd__chips">' + d.carriers.map(carrierChip).join('') + '</div></div>' : '';
    var link = d.website ? '<a class="hp-btn hp-btn-ghost bwd__visit" href="' + esc(d.website) + '" target="_blank" rel="noopener">Visit ' + esc(d.platform || 'site') + ' ↗</a>' : '';
    var ig = d.instagram ? '<a class="hp-btn hp-btn-ghost bwd__visit" href="' + esc(d.instagram) + '" target="_blank" rel="noopener">Instagram ↗</a>' : '';
    var mail = d.email ? '<a class="bwd__email" href="mailto:' + esc(d.email) + '">Email ✉</a>' : '';
    var loc = '📍 ' + (d.city_region ? esc(d.city_region) + ', ' : '') + esc(d.state_region) + (d.country !== 'USA' ? ' · ' + esc(d.country) : '');
    return '<article class="hp-card bwd__card" tabindex="0" data-id="' + esc(d.handle) + '">' +
      '<button class="bwd__onmap" data-id="' + esc(d.handle) + '" aria-label="Show ' + esc(d.name) + ' on map"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 21s-7-5-7-11a7 7 0 0114 0c0 6-7 11-7 11z"/><circle cx="12" cy="10" r="2.5"/></svg>Map</button>' +
      '<h3 class="bwd__name">' + esc(d.name) + '</h3>' +
      '<p class="bwd__loc">' + loc + '</p>' +
      '<div class="bwd__badges">' + badges + '</div>' +
      price + tryon +
      '<div class="bwd__actions">' + link + ig + mail + '</div>' +
      '</article>';
  }

  function render() {
    var shown = DATA.filter(matches);
    if (state.sortByDistance && state.userLoc) {
      shown.forEach(function (d) { d._mi = distMi(state.userLoc, d); });
      shown.sort(function (a, b) { return a._mi - b._mi; });
    } else { shown.forEach(function (d) { delete d._mi; }); }
    var zs = usZipState(state.q.trim());
    var label = 'Showing ' + shown.length + ' of ' + DATA.length + ' libraries';
    if (state.sortByDistance && state.userLoc) label = 'Nearest to you · ' + shown.length + ' shown';
    else if (zs) label = (STATES[zs] || zs) + ' · ' + shown.length + ' ' + (shown.length === 1 ? 'library' : 'libraries');
    if (el.count) el.count.textContent = label;
    if (el.mapcount) el.mapcount.textContent = shown.length + ' libraries';
    var pageItems = shown.slice(0, state.visible);
    el.list.innerHTML = shown.length ? pageItems.map(cardHTML).join('') : '<div class="bwd__empty"><h3>No libraries match yet</h3><p>Try a broader search or clear a filter.</p></div>';
    el.list.querySelectorAll('.bwd__onmap').forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); focusOnMap(b.dataset.id); }); });
    if (el.more) {
      if (shown.length > state.visible) {
        el.more.hidden = false;
        var step = Math.min(PAGE_SIZE, shown.length - state.visible);
        if (el.showmore) el.showmore.textContent = 'Show ' + step + ' more';
        if (el.showall) el.showall.textContent = 'Show all ' + shown.length;
      } else {
        el.more.hidden = true;
      }
    }
    updateMarkers(shown); // map always plots the full match set, not the paged list
  }

  var map, markers = {}, youMarker = null;
  function initMap() {
    if (state.mapReady || typeof L === 'undefined') return;
    map = L.map(el.mapEl, { scrollWheelZoom: false, zoomControl: true, tap: true, minZoom: 2, worldCopyJump: true, maxBounds: [[-85, -200], [85, 200]], maxBoundsViscosity: 0.6 }).setView([39.5, -98.4], 4);
    map.zoomControl.setPosition('topright'); // popups open upward from markers — keep the top-left clear so they aren't clipped
    // CARTO started watermarking keyless raster tiles in Aug 2026. The key is referer-restricted
    // at CARTO, so shipping it to the browser is safe; without one the basemap still draws, stamped.
    var KEYLESS_TILES = 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png';
    var tileKey = (root.dataset.tileKey || '').trim();
    var tiles = L.tileLayer(tileKey ? KEYLESS_TILES + '?key=' + encodeURIComponent(tileKey) : KEYLESS_TILES, { attribution: '&copy; OpenStreetMap &copy; CARTO', subdomains: 'abcd', maxZoom: 19 }).addTo(map);
    // A key CARTO rejects (usually this domain missing from its referer allowlist) 403s every tile and
    // leaves the map blank. Drop back to the keyless endpoint: watermarked, but still a readable map.
    // Threshold rather than first error so one flaky tile doesn't downgrade an otherwise working key.
    if (tileKey) {
      var tileErrors = 0;
      tiles.on('tileerror', function () {
        if (tileErrors === -1 || ++tileErrors < 3) return;
        tileErrors = -1;
        tiles.setUrl(KEYLESS_TILES);
      });
    }
    var legend = L.control({ position: 'bottomleft' });
    legend.onAdd = function () { var e = L.DomUtil.create('div', 'bwd__legend'); e.innerHTML = '<i class="k"></i>Carries hope&plum<br><i class="p"></i>Other library'; return e; };
    legend.addTo(map);
    DATA.forEach(function (d) {
      var icon = L.divIcon({ className: '', html: '<div class="bwd__pin ' + (hasHP(d) ? 'is-hp' : '') + '" data-id="' + esc(d.handle) + '"><span>' + (hasHP(d) ? '♥' : '') + '</span></div>', iconSize: [24, 24], iconAnchor: [12, 24], popupAnchor: [0, -22] });
      var m = L.marker([d.latitude, d.longitude], { icon: icon });
      m.bindPopup(popupHTML(d));
      markers[d.handle] = m;
      m.on('popupopen', function () {
        root.querySelectorAll('.bwd__pin').forEach(function (p) { p.classList.toggle('is-active', p.dataset.id === d.handle); });
        var b = document.querySelector('.bwd__pbtn[data-goto]'); if (b) b.addEventListener('click', function () { gotoCard(b.dataset.goto); });
      });
      m.on('popupclose', function () { root.querySelectorAll('.bwd__pin.is-active').forEach(function (p) { p.classList.remove('is-active'); }); });
    });
    state.mapReady = true;
    updateMarkers(DATA.filter(matches));
    showYou();
  }
  function popupHTML(d) {
    var types = hasHP(d) ? d.carriers.map(function (c) { return c.type; }).filter(function (v, i, a) { return a.indexOf(v) === i; }).join(', ') : '';
    return '<span class="bwd__pt">' + esc(d.name) + '</span><span class="bwd__pl">' + (d.city_region ? esc(d.city_region) + ', ' : '') + esc(d.state_region) + (d.country !== 'USA' ? ' · ' + esc(d.country) : '') + '</span>' +
      (hasHP(d) ? '<span class="bwd__ptry"><span class="bwd__lab">hope&amp;plum to try here</span><b>' + esc(types) + '</b></span>' : '') +
      '<a class="bwd__pbtn" data-goto="' + esc(d.handle) + '">View details</a>';
  }
  function updateMarkers(shown) {
    if (!state.mapReady) return;
    var ids = new Set(shown.map(function (d) { return d.handle; }));
    DATA.forEach(function (d) { var m = markers[d.handle]; if (!m) return; ids.has(d.handle) ? m.addTo(map) : map.removeLayer(m); });
    fitView(shown);
  }
  function fitView(shown) {
    if (state.sortByDistance && state.userLoc) { map.setView([state.userLoc.lat, state.userLoc.lng], 8); showYou(); return; }
    var pts = shown.map(function (d) { return [d.latitude, d.longitude]; });
    if (!pts.length) return;
    var active = state.q.trim() !== '' || state.filters.size > 0;
    if (active) { try { map.fitBounds(pts, { padding: [36, 36], maxZoom: 9 }); } catch (e) { } }
    else { map.setView([39.5, -98.4], 4); }
  }
  function showYou() {
    if (!state.mapReady || !state.userLoc) return;
    if (youMarker) map.removeLayer(youMarker);
    youMarker = L.marker([state.userLoc.lat, state.userLoc.lng], { icon: L.divIcon({ className: '', html: '<div class="bwd__youpin"></div>', iconSize: [18, 18], iconAnchor: [9, 9] }), zIndexOffset: 1000, interactive: false }).addTo(map);
  }
  function ensureMapVisible() {
    if (isDesktop()) { initMap(); setTimeout(function () { map && map.invalidateSize(); }, 60); return; }
    el.mapview.classList.add('is-open'); el.mapview.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden'; initMap();
    setTimeout(function () { if (map) { map.invalidateSize(); updateMarkers(DATA.filter(matches)); } }, 220);
  }
  function focusOnMap(id) {
    ensureMapVisible();
    var d = DATA.find(function (x) { return x.handle === id; }); if (!d) return;
    setTimeout(function () {
      if (!map) return;
      map.setView([d.latitude, d.longitude], 8); markers[id] && markers[id].openPopup();
      root.querySelectorAll('.bwd__pin').forEach(function (p) { p.classList.toggle('is-active', p.dataset.id === id); });
    }, isDesktop() ? 80 : 240);
  }
  function closeMap() { el.mapview.classList.remove('is-open'); el.mapview.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  function gotoCard(id) {
    if (!isDesktop()) closeMap();
    var card = root.querySelector('.bwd__card[data-id="' + (window.CSS && CSS.escape ? CSS.escape(id) : id) + '"]');
    root.querySelectorAll('.bwd__card').forEach(function (c) { c.classList.toggle('is-active', c.dataset.id === id); });
    if (card) card.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function setFilter(f, on) {
    on ? state.filters.add(f) : state.filters.delete(f);
    root.querySelectorAll('.bwd__chip[data-f="' + f + '"]').forEach(function (c) { c.setAttribute('aria-pressed', String(on)); });
    state.visible = PAGE_SIZE;
    render();
  }
  function setGeo(t) { if (!el.geostatus) return; el.geostatus.textContent = t; el.geostatus.style.display = t ? 'block' : 'none'; }
  function clearNear() {
    state.sortByDistance = false; state.userLoc = null; state.visible = PAGE_SIZE;
    if (el.nearme) { el.nearme.classList.remove('is-on'); var l = el.nearme.querySelector('.bwd__nearme-lbl'); if (l) l.textContent = 'Use my location'; }
    setGeo('');
    if (youMarker && state.mapReady) { map.removeLayer(youMarker); youMarker = null; }
    render();
  }

  // ---- Wire events ----
  if (el.q) el.q.addEventListener('input', function (e) { state.q = e.target.value; state.visible = PAGE_SIZE; render(); });
  root.querySelectorAll('.bwd__chip').forEach(function (ch) { ch.addEventListener('click', function () { setFilter(ch.dataset.f, ch.getAttribute('aria-pressed') !== 'true'); }); });
  if (el.reset) el.reset.addEventListener('click', function () {
    state.q = ''; state.filters.clear(); if (el.q) el.q.value = '';
    root.querySelectorAll('.bwd__chip').forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
    state.visible = PAGE_SIZE;
    if (state.sortByDistance) clearNear(); else render();
  });
  if (el.nearme) el.nearme.addEventListener('click', function () {
    if (state.sortByDistance) { clearNear(); return; }
    if (!navigator.geolocation) { setGeo('Geolocation isn’t supported in this browser.'); return; }
    setGeo('Locating you…');
    navigator.geolocation.getCurrentPosition(
      function (pos) {
        state.userLoc = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        state.sortByDistance = true;
        el.nearme.classList.add('is-on'); var l = el.nearme.querySelector('.bwd__nearme-lbl'); if (l) l.textContent = 'Clear location';
        setGeo(''); state.visible = PAGE_SIZE; render(); showYou();
        if (state.mapReady) map.setView([state.userLoc.lat, state.userLoc.lng], 8);
      },
      function (err) { setGeo(err && err.code === 1 ? 'Location permission denied — try typing a zip or town.' : 'Couldn’t get your location — try typing a zip or town.'); },
      { enableHighAccuracy: false, timeout: 9000, maximumAge: 300000 }
    );
  });
  if (el.showmore) el.showmore.addEventListener('click', function () { state.visible += PAGE_SIZE; render(); });
  if (el.showall) el.showall.addEventListener('click', function () { state.visible = 1e9; render(); });
  if (el.openMap) el.openMap.addEventListener('click', ensureMapVisible);
  if (el.closeMap) el.closeMap.addEventListener('click', closeMap);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !isDesktop()) closeMap(); });
  var rz; window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(function () { syncCtrlHeight(); if (isDesktop()) { closeMap(); initMap(); map && map.invalidateSize(); } }, 200); });

  // ---- Boot: load data (inline blob first, else fetch the asset), then render ----
  function fillStats() {
    var total = DATA.length;
    var hp = DATA.filter(hasHP).length;
    var countries = new Set(DATA.map(function (d) { return d.country; }).filter(Boolean)).size;
    var set = function (key, val) { var n = root.querySelector('[data-bwd-stat="' + key + '"] .hp-stat__metric'); if (n) n.textContent = val; };
    set('libraries', total); set('hp', hp); set('countries', countries);
  }
  // Desktop map is lazy-initialised only when it nears the viewport, so Leaflet
  // and the tile requests don't fire until needed. Mobile defers via the FAB.
  function armMapLazyInit() {
    if (!isDesktop()) return;
    var go = function () { initMap(); setTimeout(function () { map && map.invalidateSize(); }, 120); };
    if (!('IntersectionObserver' in window)) { go(); return; }
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); go(); }
    }, { rootMargin: '300px' });
    io.observe(el.mapview);
  }
  // The desktop sticky map offsets by the real controls-bar height (not a fixed guess) to avoid overlap.
  function syncCtrlHeight() {
    var c = root.querySelector('.bwd__controls');
    if (c) root.style.setProperty('--bwd-ctrl-h', c.offsetHeight + 'px');
  }
  function boot(libraries) {
    DATA = Array.isArray(libraries) ? libraries : [];
    fillStats();
    render();
    syncCtrlHeight();
    armMapLazyInit();
  }
  var carrierMap = root.querySelector('script[type="application/json"][data-bwd-carrier-collections]');
  if (carrierMap) {
    try {
      var m = JSON.parse(carrierMap.textContent);
      Object.keys(m).forEach(function (k) { if (m[k]) CARRIER_URLS[k] = m[k]; });
    } catch (e) { /* leave chips as non-links */ }
  }
  var inline = root.querySelector('script[type="application/json"][data-bwd-data]');
  if (inline) {
    try { var parsed = JSON.parse(inline.textContent); boot(parsed.libraries || parsed); }
    catch (e) { console.error('[babywearing-directory] bad inline data', e); }
  } else if (root.dataset.src) {
    fetch(root.dataset.src)
      .then(function (r) { return r.json(); })
      .then(function (json) { boot(json.libraries || json); })
      .catch(function (e) { console.error('[babywearing-directory] fetch failed', e); el.list.innerHTML = '<div class="bwd__empty"><h3>Directory unavailable</h3><p>Please refresh to try again.</p></div>'; });
  }
})();
